/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PerformanceLaneMonthRow } from "./PerformanceLaneMonthRow";
import {
  PerformanceLaneMonthRowFromJSON,
  PerformanceLaneMonthRowFromJSONTyped,
  PerformanceLaneMonthRowToJSON,
  PerformanceLaneMonthRowToJSONTyped,
} from "./PerformanceLaneMonthRow";
import type { PerformanceLaneShipment } from "./PerformanceLaneShipment";
import {
  PerformanceLaneShipmentFromJSON,
  PerformanceLaneShipmentFromJSONTyped,
  PerformanceLaneShipmentToJSON,
  PerformanceLaneShipmentToJSONTyped,
} from "./PerformanceLaneShipment";
import type { PortalCurrency } from "./PortalCurrency";
import {
  PortalCurrencyFromJSON,
  PortalCurrencyFromJSONTyped,
  PortalCurrencyToJSON,
  PortalCurrencyToJSONTyped,
} from "./PortalCurrency";
import type { PerformanceLaneRow } from "./PerformanceLaneRow";
import {
  PerformanceLaneRowFromJSON,
  PerformanceLaneRowFromJSONTyped,
  PerformanceLaneRowToJSON,
  PerformanceLaneRowToJSONTyped,
} from "./PerformanceLaneRow";

/**
 *
 * @export
 * @interface PerformanceLaneDetail
 */
export interface PerformanceLaneDetail {
  /**
   *
   * @type {PortalCurrency}
   * @memberof PerformanceLaneDetail
   */
  currency: PortalCurrency;
  /**
   *
   * @type {PerformanceLaneRow}
   * @memberof PerformanceLaneDetail
   */
  lane: PerformanceLaneRow;
  /**
   *
   * @type {Array<PerformanceLaneShipment>}
   * @memberof PerformanceLaneDetail
   */
  shipments: Array<PerformanceLaneShipment>;
  /**
   *
   * @type {Array<PerformanceLaneMonthRow>}
   * @memberof PerformanceLaneDetail
   */
  byMonth: Array<PerformanceLaneMonthRow>;
}

/**
 * Check if a given object implements the PerformanceLaneDetail interface.
 */
export function instanceOfPerformanceLaneDetail(
  value: object,
): value is PerformanceLaneDetail {
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("lane" in value) || value["lane"] === undefined) return false;
  if (!("shipments" in value) || value["shipments"] === undefined) return false;
  if (!("byMonth" in value) || value["byMonth"] === undefined) return false;
  return true;
}

export function PerformanceLaneDetailFromJSON(
  json: any,
): PerformanceLaneDetail {
  return PerformanceLaneDetailFromJSONTyped(json, false);
}

export function PerformanceLaneDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceLaneDetail {
  if (json == null) {
    return json;
  }
  return {
    currency: PortalCurrencyFromJSON(json["currency"]),
    lane: PerformanceLaneRowFromJSON(json["lane"]),
    shipments: (json["shipments"] as Array<any>).map(
      PerformanceLaneShipmentFromJSON,
    ),
    byMonth: (json["byMonth"] as Array<any>).map(
      PerformanceLaneMonthRowFromJSON,
    ),
  };
}

export function PerformanceLaneDetailToJSON(json: any): PerformanceLaneDetail {
  return PerformanceLaneDetailToJSONTyped(json, false);
}

export function PerformanceLaneDetailToJSONTyped(
  value?: PerformanceLaneDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    currency: PortalCurrencyToJSON(value["currency"]),
    lane: PerformanceLaneRowToJSON(value["lane"]),
    shipments: (value["shipments"] as Array<any>).map(
      PerformanceLaneShipmentToJSON,
    ),
    byMonth: (value["byMonth"] as Array<any>).map(
      PerformanceLaneMonthRowToJSON,
    ),
  };
}
